/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ambient_Temperature_Setpoint_On_OccupationInputs */



/**
* | output |
* | --- |
* | "Ambient setpoint during occupation" |
*
* @param {Ambient_Temperature_Setpoint_On_OccupationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const ambient_temperature_setpoint_on_occupation = /** @type {((inputs?: Ambient_Temperature_Setpoint_On_OccupationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ambient_Temperature_Setpoint_On_OccupationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Ambient setpoint during occupation")
	return /** @type {LocalizedString} */ ("Consigne d'ambiance en occupation")
});